import { gql } from "@apollo/client";

export const CREATE_STUDENT = gql`
mutation createStudent($input:createStudentInput!) {
  addStudent(input: $input) {
    message
  }
}
`;

export const VERIFY_CLASS_CODE_STUDENT = gql`
query verifyClassroomCodeForStudent($cCode: String!) {
  verifyClassCodeForStudentV2(cCode: $cCode) {
    cId
  }
}
`;

export const CREATE_PTA = gql`
mutation addPta($input: createPtaInput!) {
  addPta(input: $input)
}
`;

export const FORGOT_PASSWORD_STUDENT = gql`
mutation sendForgotPasswordMail($input: forgotMailInput!) {
  sendForgotPasswordMail(input: $input)
}
`;
export const UPDATE_APP_VERSION = gql`
mutation updateUserAppVersion($versionData: JSON) {
  updateUserAppVersion(input: {versionData: $versionData})
}
`;

export const GET_VIRTUAL_CLASS_LEVELS = gql`
query allClassrooms{
  allClassrooms(
    filter: {schoolAdminBySaId: {adminType: {equalTo: VIRTUAL}}, deletedAt: {isNull: true}}
  ) {
    nodes {
      cId
      cName
      cOriginalName
    }
    totalCount
  }
}
`;
